import React from 'react';
import SeoHead from '../components/SeoHead';
import { CORE_PAGE_SEO } from '../data/corePageSeo';
import { SERVICE_PAGE_CONTENT } from '../data/servicePageContent';

const WhyIcon = ({ children }) => (
  <span className="why-service-icon">
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      {children}
    </svg>
  </span>
);

const ServicesPage = () => {
  const seo = CORE_PAGE_SEO.services;

  return (
    <main>
      <SeoHead title={seo.title} description={seo.description} path={seo.path} />
      {/* Page Banner */}
      <section className="page-banner block-space text-white" style={{ backgroundColor: 'var(--secondary-color)' }}>
        <div className="container">
          <h1 id="service-page-list-heading" className="display-4 fw-bold">Our Taxi Services</h1>
          <p className="lead">
            Station transfers, outstation drops, hourly cabs, and planned tours with professional drivers and clear fares
          </p>
        </div>
      </section>

      <section className="service-page-list block-space" aria-labelledby="service-page-list-heading">
        <div className="container">
          <div className="service-page-grid">
            {SERVICE_PAGE_CONTENT.map((service) => (
              <article key={service.id} id={service.id} className="service-page-card">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Our Services */}
      <section className="why-our-services block-space bg-light">
        <div className="container">
          <h2 className="section-title">Why Choose Our Services</h2>
          <div className="row">
            <div className="col-md-6 mb-3">
              <div className="feature-item d-flex">
                <WhyIcon>
                  <circle cx="7.4" cy="6.6" r="2.2" />
                  <path d="M3.2 17.6v-.6c0-2.2 1.9-3.8 4.2-3.8s4.2 1.6 4.2 3.8v.6" />
                  <path d="M16.8 9.8l3.4.9v2.6c0 2-1.45 3.3-3.4 3.9-1.95-.6-3.4-1.9-3.4-3.9v-2.6l3.4-.9z" />
                  <path d="M15.35 13.7l1.15 1.15 2.35-2.4" />
                </WhyIcon>
                <div>
                  <h6>Professional Drivers</h6>
                  <p className="text-muted mb-0">Trained and experienced drivers committed to your satisfaction.</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <div className="feature-item d-flex">
                <WhyIcon>
                  <path d="M4 14.6h13.6" />
                  <path d="M5.7 14.6l1.35-3.6c.2-.55.75-.95 1.35-.95h5.5c.6 0 1.15.4 1.35.95l1.35 3.6" />
                  <path d="M4 14.6v1.45c0 .4.3.7.7.7H5.6" />
                  <path d="M16.2 16.75h.9c.4 0 .7-.3.7-.7V14.6" />
                  <circle cx="7.5" cy="16.75" r="1.2" />
                  <circle cx="14.5" cy="16.75" r="1.2" />
                  <path d="M18.7 3.4v2.7M17.35 4.75h2.7" />
                  <path d="M16.7 7.15v1.45M15.95 7.9h1.5" />
                </WhyIcon>
                <div>
                  <h6>Clean Vehicles</h6>
                  <p className="text-muted mb-0">Well-maintained and regularly sanitized vehicles.</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <div className="feature-item d-flex">
                <WhyIcon>
                  <path d="M12 20.8s5.4-4.7 5.4-8.9a5.4 5.4 0 1 0-10.8 0c0 4.2 5.4 8.9 5.4 8.9z" />
                  <circle cx="12" cy="11.7" r="1.65" />
                </WhyIcon>
                <div>
                  <h6>GPS Tracking</h6>
                  <p className="text-muted mb-0">Real-time tracking for your peace of mind.</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <div className="feature-item d-flex">
                <WhyIcon>
                  <circle cx="12" cy="12.4" r="6.15" />
                  <path d="M12 9.2V12.4l2.25 1.45" />
                  <path d="M12 7.15v1.15M12 16.5v1.15M7.15 12.4h1.15M15.7 12.4h1.15" />
                </WhyIcon>
                <div>
                  <h6>24/7 Availability</h6>
                  <p className="text-muted mb-0">Round-the-clock service for your convenience.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ServicesPage;
